import type { FaireProductEntity } from "../../entity_types/product";

export const p_dh9rr5qtug: FaireProductEntity = {
  token: "p_dh9rr5qtug",
  type: "product",
  name: "Knotted Gown | Newborn, baby clothes, gender neutral",
  brandToken: "b_661ovrgbd0",
  brandName: "Papillon Bebe",
  imageUrl:
    "https://cdn.faire.com/fastly/81b20b683fa27fd1fa2e5b7b9a187516336b848312eb714666fa315a7a75fabd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7eb2b5cc022f9f400619085260c630f07f545f012f38719ed79afdd2ee0bc1f8.jpeg",
    "https://cdn.faire.com/fastly/e7bf58aa2c19e662667310bd3c9760cf861e414388afca4aef3fe0dec53e3c43.jpeg",
    "https://cdn.faire.com/fastly/0208be678702dc4469dd41e2ac897ee1c15ad78a93f9e7e527f7c2a984bd20e1.jpeg",
    "https://cdn.faire.com/fastly/aa32b92a5cb35628ca09924a1c0192ccad4322e739b1f9c0692e40a90ea187b8.jpeg",
    "https://cdn.faire.com/fastly/9af34dd2638b5905688976958ad0fdceec20455678f38967e0bf88e9eb35c6cc.jpeg",
    "https://cdn.faire.com/fastly/27c07933ca06998cee41acfd7999ce125a6cd5bea4db806630770551cdfd90d2.jpeg",
    "https://cdn.faire.com/fastly/c5e9bef279513b39ff451022b78deb5c186a021470de2049a18ea9a46594fdf3.jpeg",
    "https://cdn.faire.com/fastly/a8091df92a51d7a33a1672a8e94b91f398d9b288a3d7c30519459ccac1f5b329.jpeg",
    "https://cdn.faire.com/fastly/8ff1713ab0581b4f6f6b110ea572df02cca7fff009ddcc2328898a0ceee5d51d.jpeg",
    "https://cdn.faire.com/fastly/9b9bbe84283dfecc902f6fcfd359d48fad13c040bc230fb9260245155b9dd014.jpeg",
    "https://cdn.faire.com/fastly/e0a1b3258aff8f6fad91a30b74ddb3e9ed995aa0dce1178986f236416881479c.jpeg",
    "https://cdn.faire.com/fastly/b889da571f6e4a8b4a0dea87f106dad57f0ffa3898882b87481c9a650db7634f.jpeg",
    "https://cdn.faire.com/fastly/7631b9ab498384a746a2681f959218371624be2e30b9b50c0c6ef92171260cd3.jpeg",
    "https://cdn.faire.com/fastly/443d0b69bc13abf8c141215000c71ef1f34ca06248a9c2a9fc688513e0531762.jpeg",
    "https://cdn.faire.com/fastly/625df80a154869fd91bee195b36d842e3783930f1b092c36e445ffaa69e1980c.jpeg",
    "https://cdn.faire.com/fastly/c7c56daa4a29133a0046a6f5b1f3b5134cdbe6818e5c705c400ea45e784f8a3e.jpeg",
  ],
  priceDollars: 15,
  description:
    "Made from our super soft and stretchy material, you will want to keep your baby in this at all times!  Functional buttons and easy access for diaper changes while still keeping baby warm and comfortable.\n\nMATERIALS\n- Rayon/Spandex Blend\n- Machine wash cold, with similar colors; line dry.\n- Wooden Buttons",
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:47.987Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
